import React from "react"
import LazyAndPreloadImage from "../functions/lazy_and_preload_image"
import { Link, graphql, useStaticQuery } from 'gatsby'
import {BackToTopButton} from "./back-to-top-button";

export default function Footer() {
  // 最新のニューズレターを取得する
  const latestNewsletter = useStaticQuery (
    graphql`
    query LatestNewsletterIdQuery {
      allMicrocmsNewsletters(
        limit: 1, sort: {fields: date, order: DESC}
      ) {
        edges {
          node {
            newslettersId
          }
        }
      }
    }`
  )
  const latestNewsLetterId = latestNewsletter.allMicrocmsNewsletters.edges[0].node.newslettersId;

  return (
    <footer>
      <script src="https://code.jquery.com/jquery-3.4.1.min.js" />
      <div className="footer">
        <div className="footer_in">
          <div className="w_footer_flex">
            <div className="footer_flex_wrap flexitem1">
              <Link className="logo" to="/"><LazyAndPreloadImage imgUrl={"/images/pc/common/jfeel_logo.svg"} alt="フッターのロゴ" /></Link>
              <div className="fotter_pc_only">
                <dl className="corporate_information">
                  <dt>株式会社ジェイフィール</dt>
                  <dd>
                    <ul className="add">
                      <li><span style={{ lineHeight: '125%' }}>東京都渋谷区渋谷3-3-2 <br/>アーバンセンター渋谷イースト6F</span></li>
                      <li><span className="add_ttl">Tel.</span><span>03-5468-8655</span></li>
                      <li><span className="add_ttl">Fax.</span><span>03-5468-8656</span></li>
                    </ul>
                  </dd>
                </dl>
                <div className="footer_social">
                  <ul>
                    <li className="instagram"><a href="https://www.instagram.com/jfeelinc/"><LazyAndPreloadImage imgUrl={"/images/pc/common/instagram_ico.png"} alt="インスタグラムロゴ" /></a></li>
                    <li className="facebook"><a href="https://www.facebook.com/J.Feeel.inc/"><LazyAndPreloadImage imgUrl={"/images/pc/common/facebook_ico.png"} alt="ファイスブックロゴ" /></a></li>
                    <li className="twitter"><a href="https://twitter.com/JFEELofficial"><LazyAndPreloadImage imgUrl={"/images/pc/common/x_ico.png"} alt="ツイッターロゴ" /></a></li>
                    <li className="rss"><a href="/atom.xml"><LazyAndPreloadImage imgUrl={"/images/pc/common/rss_ico.png"} alt="RSSロゴ" /></a></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="flex_wrap pc_only">
              <div className="footer_flex">
                <Link className="footer_link_title" to="/philosophy">Philosophy</Link>
                <ul className="footerlink">
                  <li><Link to="/philosophy#mission_ttl">ミッション</Link></li>
                  <li><Link to="/philosophy#key_method_ttl">キーメソッド</Link></li>
                  <li><Link to="/philosophy#symbol_ttl">ジェイフィールのロゴ</Link></li>
                </ul>
              </div>
              <div className="footer_flex">
                <Link className="footer_link_title" to="/community">Community</Link>
                <ul className="footerlink">
                  <li><Link to="/community/member">メンバー</Link></li>
                  <li><Link to="/community/partner">パートナー</Link></li>
                  <li><Link to="/community/collaborator">コラボレーター</Link></li>
                </ul>
              </div>
              <div className="footer_flex">
                <Link className="footer_link_title" to="/program">Program</Link>
                <ul className="footerlink">
                  <li><Link to="/program">プログラム一覧</Link></li>
                </ul>
              </div>
              <div className="footer_flex">
                <Link className="footer_link_title" to="/seminar">Seminar</Link>
                <ul className="footerlink">
                  <li><Link to="/seminar">最新のセミナー</Link></li>
                  <li><Link to="/seminar/archive">終了したセミナー</Link></li>
                </ul>
              </div>
              <div className="footer_flex">
                <Link className="footer_link_title" to="/note">J.Feel Note</Link>
                <ul className="footerlink">
                  <li><Link to="/note#case_study_ttl">イキイキ・ワクワク事例集</Link></li>
                  <li><Link to="/note#column_ttl">ジェイフィールの自由研究</Link></li>
                  <li><Link to="/note#culture_ttl">ご機嫌な職場日記</Link></li>
                </ul>
              </div>
              <div className="footer_flex">
                <Link className="footer_link_title" to="/newsletter">NewsLetter</Link>
                <ul className="footerlink">
                  <li><Link to={`/newsletter/${latestNewsLetterId}`}>最新のニューズレター</Link></li>
                  <li><a href="https://ma.j-feel.jp/NZ_inquiry_lp.html">ニューズレターのご登録</a></li>
                </ul>
              </div>
              <div className="footer_flex">
                <Link className="footer_link_title" to="/publication">Publication</Link>
                <ul className="footerlink">
                  <li><Link to="/publication/book">書籍出版</Link></li>
                  <li><Link to="/publication/media">メディア掲載</Link></li>
                </ul></div>
              <div className="footer_flex">
                <Link className="footer_link_title" to="/company">Company</Link>
                <ul className="footerlink">
                  <li><Link to="/company">会社概要</Link></li>
                  <li><Link to="/company#supporter_ttl">サポーター</Link></li>
                  <li><Link to="/company#registered_trademark_ttl">商標登録</Link></li>
                  <li><a href="https://ma.j-feel.jp/inquiry.html">お問い合わせ</a></li>
                  <li><Link to="/recruit">採用情報</Link></li>
                  <li><Link to="/en/about">En/About us</Link></li>
                </ul>
              </div>
            </div>
            <div className="flex_wrap sp_only">
              <div className="footer_flex">
                <Link className="footer_link_title" to="/philosophy">Philosophy</Link>
                <ul className="footerlink">
                  <li><Link to="/philosophy#mission_ttl">ミッション</Link></li>
                  <li><Link to="/philosophy#key_method_ttl">キーメソッド</Link></li>
                  <li><Link to="/philosophy#symbol_ttl">ジェイフィールのロゴ</Link></li>
                </ul>
                <Link className="footer_link_title" to="/community">Community</Link>
                <ul className="footerlink">
                  <li><Link to="/community/member">メンバー</Link></li>
                  <li><Link to="/community/partner">パートナー</Link></li>
                  <li><Link to="/community/collaborator">コラボレーター</Link></li>
                </ul>
                <Link className="footer_link_title" to="/program">Program</Link>
                <ul className="footerlink">
                  <li><Link to="/program">プログラム一覧</Link></li>
                </ul>
                <Link className="footer_link_title" to="/seminar">Seminar</Link>
                <ul className="footerlink">
                  <li><Link to="/seminar">最新のセミナー</Link></li>
                  <li><Link to="/seminar/archive">終了したセミナー</Link></li>
                </ul>
              </div>
              <div className="footer_flex">
                <Link className="footer_link_title" to="/note">J.Feel Note</Link>
                <ul className="footerlink">
                  <li><Link to="/note#case_study_ttl">イキイキ・ワクワク事例集</Link></li>
                  <li><Link to="/note#column_ttl">ジェイフィールの自由研究</Link></li>
                  <li><Link to="/note#culture_ttl">ご機嫌な職場日記</Link></li>
                </ul>
                <Link className="footer_link_title" to="/newsletter">NewsLetter</Link>
                <ul className="footerlink">
                  <li><Link to={`/newsletter/${latestNewsLetterId}`}>最新のニューズレター</Link></li>
                  <li><a href="https://ma.j-feel.jp/NZ_inquiry_lp.html">ニューズレターのご登録</a></li>
                </ul>
                <Link className="footer_link_title" to="/publication">Publication</Link>
                <ul className="footerlink">
                  <li><Link to="/publication/book">書籍出版</Link></li>
                  <li><Link to="/publication/media">メディア掲載</Link></li>
                </ul>
                <Link className="footer_link_title" to="/company">Company</Link>
                <ul className="footerlink">
                  <li><Link to="/company">会社概要</Link></li>
                  <li><Link to="/company#supporter_ttl">サポーター</Link></li>
                  <li><Link to="/company#registered_trademark_ttl">商標登録</Link></li>
                  <li><a href="https://ma.j-feel.jp/inquiry.html">お問い合わせ</a></li>
                  <li><Link to="/recruit">採用情報</Link></li>
                  <li><Link to="/en/about">En/About us</Link></li>
                </ul>
              </div>
            </div>
          </div>{/* /w_footer_flex */}
          <div className="sp_only">
            <dl className="corporate_information">
              <dt>株式会社ジェイフィール</dt>
              <dd style={{ lineHeight: '125%' }}>東京都渋谷区渋谷3-3-2<br />アーバンセンター渋谷イースト6F</dd>
              <dd>
                <ul className="add">
                  <li><span className="add_ttl">Tel.</span><span>03-5468-8655</span></li>
                  <li><span className="add_ttl">Fax.</span><span>03-5468-8656</span></li>
                </ul>
              </dd>
            </dl>
            <div className="footer_social">
              <ul>
                <li className="instagram"><a href="https://www.instagram.com/jfeelinc/"><LazyAndPreloadImage imgUrl={"/images/pc/common/instagram_ico.png"} alt="インスタグラムロゴ" /></a></li>
                <li className="facebook"><a href="https://www.facebook.com/J.Feeel.inc/"><LazyAndPreloadImage imgUrl={"/images/pc/common/facebook_ico.png"} alt="ファイスブックロゴ" /></a></li>
                <li className="twitter"><a href="https://twitter.com/JFEELofficial"><LazyAndPreloadImage imgUrl={"/images/pc/common/twitter_ico.png"} alt="ツイッターロゴ" /></a></li>
                <li className="rss"><a href="/atom.xml"><LazyAndPreloadImage imgUrl={"/images/pc/common/rss_ico.png"} alt="RSSロゴ" /></a></li>
              </ul>
            </div>
          </div>
          <div className="wrap">
            <div className="copy">©J.Feel Inc All Rights Reserved.</div>
            <ul className="foot_link">
              <li>This is our</li>
              <li> <Link to="/policy">Privacy Policy</Link> /</li>
              <li><Link to="/terms">Terms.</Link></li>
            </ul>
          </div>
        </div>{/* footer_in */}
          <BackToTopButton />
      </div>{/* footer */}
    </footer>
  )
}
